module.exports = __webpack_public_path__ + "static/juha.56c92108.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Bio/juha.jpg
// module id = ./src/components/Bio/juha.jpg
// module chunks = 4016850265702045000 9418601260560796000